import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-post400",
  "use": "icon-post400-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-post400\"><text transform=\"translate(-8 -5)\" fill=\"#2A2D44\" fill-rule=\"evenodd\" font-family=\"AppleColorEmoji, Apple Color Emoji\" font-size=\"12\">\r\n                        <tspan x=\"8\" y=\"18\">🥳</tspan>\r\n                    </text></symbol>"
});
var result = sprite.add(symbol);
export default symbol